import React from "react";
import "./StakingHero.css";
import image from "../../assets/images/staking-hero-removebg-preview.png";
import icon1 from "../../assets/images/growth-icon.png";
import icon2 from "../../assets/images/apy-icon.png";
import icon3 from "../../assets/images/buyback-icon.png";
import icon4 from "../../assets/images/assurance-icon.png";

function StakingHero() {
  return (
    <div className="stakingHero">
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="days-one">
            {/* The best Auto-Staking <br /> & Auto-Compounding <br />{" "}
            <span style={{ color: "#17ccf8" }}>Protocol in Crypto</span> */}
            <span style={{ color: "#17ccf8" }}>EARN, INSURE, AND GROW:</span>{" "}
            <br />
            Wealth Accumulation & <br /> Financial Security
          </h1>
          <p>
            Empowering All with Safe and Consistent Wealth Growth. Join us at
            INFINITY in shaping a future where financial empowerment knows no
            bounds, transcending backgrounds and locations.
          </p>
          <div className="hero-btns">
            <button className="button1">Enter App</button>
            <button className="button2">Read Whitepaper</button>
          </div>
        </div>
        <div className="hero-image">
          <img src={image} alt="Hero" />
        </div>
      </div>
      <div className="under-hero">
        <div className="each-under-hero">
          <img src={icon1} alt="" />
          <p>sustainable growth</p>
        </div>
        <div className="each-under-hero">
          <img src={icon2} alt="" />
          <p>Attractive APY</p>
        </div>
        <div className="each-under-hero">
          <img src={icon3} alt="" />
          <p>Auto Reinvesting</p>
        </div>
        <div className="each-under-hero">
          <img src={icon4} alt="" />
          <p>Anti-Dump</p>
        </div>
      </div>
      <div className="blur"></div>
    </div>
  );
}

export default StakingHero;
